<template lang="pug">
	
	div

		form

			div.form-group
				
				label.required Arquivo shape:

				shape-input(ref="shapeInput"
						v-model="geoJsonShape",
						name="shape",
						v-validate="'required'",
						:max-file-size="tamanhoMaximoShapeMB",
						:max-geometries="1",
						:accept-polygons="true",
						@input="onShapeChange")

				input-errors(name="shape")

</template>

<script>

import LeafletUtils from '@/utils/leafletUtils';
import ShapeInput from '@/components/utils/ShapeInput';
import InputErrors from '@/components/utils/InputErrors';
import Estilo from '@/models/estilo';
import TipoGeometria from '@/models/tipoGeometria';
import Config from '@/config.js';

export default {

	name: 'InspecaoShape',

	components: { ShapeInput, InputErrors },

	props: {
		maxAreaHA: {
			type: Number,
			required: true
		}
	},

	data () {
		return {
			geoJsonShape: null,
			geometria: null,
			tipoGeometria: null,
			tamanhoMaximoShapeMB: Config.inspecao.tamanhoMaximoShapeMB
		};
	},

	/**
	 * Configura as validações relacionadas ao shape selecionado.
	 */
	mounted () {

		this.$validator.addComponentRule(this.$refs.shapeInput, {
			getMessage: field => 'O shape excede o limite máximo de ' + this.maxAreaHA + ' ha.',
			validate: (value) => !this.geometriaExcedeAreaMaxima()
		});
	},

	methods: {

		/**
		 * Executado quando um shape é selecionado, cria uma camada para ele,
		 * e se passar nas validações, esta camada é adicionada ao mapa.
		 */
		onShapeChange (geoJson) {
			
			this.removerGeometriasMapa();

			if (!geoJson || geoJson.msg) return;

			this.tipoGeometria = TipoGeometria.getFromGeoJson(geoJson);
			
			let style = Estilo.getStyleInspecao(this.tipoGeometria);

			let layer = LeafletUtils.createGeoJsonLayer(geoJson, style);

			this.geometria = {
				layer: layer,
				area: LeafletUtils.getLayerArea(layer)
			};

			this.validar(() => {

				this.geometria.layer = this.getPolygonLayer();
				this.$mapa.addLayer(this.geometria.layer);

				this.$bus.$emit('mapa.centerLayer', this.geometria.layer);
			});
		},

		/**
		 * Verifica se o shape informado excede à area máxima permitida.
		 */
		geometriaExcedeAreaMaxima () {

			return this.tipoGeometria && this.geometria && this.geometria.area &&
					this.tipoGeometria.codigo === TipoGeometria.POLIGONO.codigo &&
					this.geometria.area > this.maxAreaHA;
		},

		/**
		 * Normalmente os shapes, quando convertidos para geoJson, geram uma
		 * FeatureCollection contendo as geometria. Devido a isto, a layer acaba
		 * por ser um layerGroup com várias sub-camadas.
		 * Assim, este método verifica quantas sub-camadas o shape gerou.
		 */
		getNumeroGeometrias () {

			if (!this.geometria || !this.geometria.layer) return 0;
			
			let layer = this.geometria.layer;
			let subLayers = layer && layer.getLayers && layer.getLayers();

			if (!subLayers) return 0;

			return subLayers.length;
		},

		/**
		 * Retorna a camada que de fato contem a geometria. Ver o comentário do
		 * método 'getNumeroGeometrias'.
		 */
		getPolygonLayer () {

			if (!this.geometria || !this.geometria.layer) return null;

			if (!this.geometria.layer.getLayers) return this.geometria.layer;

			var subLayers = this.geometria.layer.getLayers();

			return subLayers.length ? subLayers[0] : null;
		},

		/**
		 * Limpa todas as informações do componente, retornando-o a seu estado inicial.
		 */
		limpar () {

			this.removerGeometriasMapa();
			this.geometria = null;
			this.$refs.shapeInput.clear();
			this.geoJsonShape = null;
			
			this.$nextTick().then(() => {
				this.$validator.cleanErrors();
			});
		},

		/**
		 * Valida se o usuário adicionou uma geometria e se ela não excede a área máxima
		 * permitida. Chamada pelo componente pai antes de efetuar a busca por informações.
		 */
		validar (callback) {

			this.$validator.cleanErrors();

			this.$validator.validateAll().then((result) => {
					
				if (result && callback) callback();
			});
		},

		/**
		 * Remove as geometria do mapa. Utilizado quando o usuário alterna para outra
		 * ferramenta de inspeção ou limpa o formulário.
		 */
		removerGeometriasMapa () {

			if (this.geometria) this.$mapa.removeLayer(this.geometria.layer);
		},

		/**
		 * Utilizado no caso do tipo de geometria for PONTO, onde ao invés
		 * do desenho do ponto, é adicionado ao mapa o marcador de inspeção.
		 */
		adicionarGeometriasMapa () {

			if (this.geometria) this.$mapa.addLayer(this.geometria.layer);
		},

		/**
		 * Retorna a geometria vetorizada. Método utilizado pelo componente pai para
		 * efetuar a busca por informações.
		 */
		getGeometria () {
			
			return this.geometria;
		}
	}
};

</script>


// WEBPACK FOOTER //
// InspecaoShape.vue?0bfc5a77